import React, { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, List, ListItem, ListItemText, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { DataGrid, GridColumnVisibilityModel, GridFilterModel, GridSortModel } from '@mui/x-data-grid'
import { DtoolRelationType } from '../../../api/appAPI'
import { StateType } from '../../../redux/store'
import { actions as appActions } from '../../../redux/appReducer'
import { saveGridStateInLocalStorage } from '../../../common/helpers'
import DefineDtoolRelation from './DefineDtoolRelation'
import EditDtoolRelation from './EditDtoolRelation'

interface IProps {
  dtoolRelationsList: DtoolRelationType[]
  activeDtoolRelationId: number
  dtoolRelationsGridVisibilityModel: GridColumnVisibilityModel | undefined
  dtoolRelationsGridSortModel: GridSortModel | undefined
  dtoolRelationsGridFilterModel: GridFilterModel | undefined

  setDtoolRelationsGridVisibilityModel(model: GridColumnVisibilityModel | undefined): void
  setDtoolRelationsGridSortModel(model: GridSortModel | undefined): void
  setDtoolRelationsGridFilterModel(model: GridFilterModel | undefined): void
  setActiveDtoolRelationId(id: number): void
}

const DtoolRelationsTab: FC<IProps> = (props) => {
  const [activeRelation, setActiveRelation] = useState<undefined | DtoolRelationType>(
    props.dtoolRelationsList.find((m) => m.id === props.activeDtoolRelationId)
  )

  useEffect(() => {
    setActiveRelation(props.dtoolRelationsList.find((h) => h.id === props.activeDtoolRelationId))
  }, [props.activeDtoolRelationId, props.dtoolRelationsList])

  useEffect(() => {
    saveGridStateInLocalStorage(
      {
        visibilityModel: props.dtoolRelationsGridVisibilityModel,
        sortModel: props.dtoolRelationsGridSortModel,
        filterModel: props.dtoolRelationsGridFilterModel,
      },
      'dtoolRelations'
    )
  }, [
    props.dtoolRelationsGridVisibilityModel,
    props.dtoolRelationsGridSortModel,
    props.dtoolRelationsGridFilterModel,
  ])

  return (
    <Box display="flex" style={{ height: window.innerHeight - 48 * 2 }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        pt={2}
        style={{ borderRight: 'solid 1px black', width: '50%' }}
      >
        <Typography variant="h6">Dtool Relations List</Typography>

        <Paper style={{ width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
          <List component="nav" style={{ padding: 0 }}>
            <ListItem
              button
              onClick={() => {
                props.setActiveDtoolRelationId(0)
              }}
            >
              <ListItemText primary="New Dtool Relation" />
              <AddIcon />
            </ListItem>
          </List>
        </Paper>

        <DataGrid
          style={{ width: '90%', maxHeight: '90%', overflowY: 'auto', marginTop: 10 }}
          columns={[
            { field: 'id', headerName: 'id', width: 100 },
            { field: 'date', headerName: 'Last Modified', type: 'datetime', minWidth: 160 },
            { field: 'name', headerName: 'name', width: 150 },
            { field: 'description', headerName: 'description', width: 200 },
            { field: 'type', headerName: 'type', width: 120 },
            { field: 'tags', headerName: 'tags', width: 150 },
            { field: 'targetId', headerName: 'targetId', width: 120 },
          ]}
          rows={props.dtoolRelationsList.map((rel) => ({
            id: rel.id,
            date: new Date(rel.date),
            name: rel.name,
            description: rel.description,
            type: rel.type,
            tags: Array.isArray(rel.tags) ? rel.tags.join(', ') : rel.tags,
            targetId: rel.targetId,
          }))}
          onRowClick={(param) => {
            props.setActiveDtoolRelationId(parseInt(param.id.toString()))
          }}
          columnVisibilityModel={props.dtoolRelationsGridVisibilityModel}
          onColumnVisibilityModelChange={(model) => {
            props.setDtoolRelationsGridVisibilityModel(model)
          }}
          sortModel={props.dtoolRelationsGridSortModel}
          onSortModelChange={(model) => {
            if (JSON.stringify(model) !== JSON.stringify(props.dtoolRelationsGridSortModel))
              props.setDtoolRelationsGridSortModel(model)
          }}
          filterModel={props.dtoolRelationsGridFilterModel}
          onFilterModelChange={(model) => {
            if (JSON.stringify(model) !== JSON.stringify(props.dtoolRelationsGridFilterModel))
              props.setDtoolRelationsGridFilterModel(model)
          }}
          rowSelectionModel={props.activeDtoolRelationId}
        />
      </Box>

      {activeRelation === undefined ? (
        <DefineDtoolRelation />
      ) : (
        <EditDtoolRelation relation={activeRelation} />
      )}
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  dtoolRelationsList: state.appReducer.dtoolRelationsList,
  activeDtoolRelationId: state.appReducer.activeDtoolRelationId,
  dtoolRelationsGridVisibilityModel: state.appReducer.dtoolRelationsGrid.visibilityModel,
  dtoolRelationsGridSortModel: state.appReducer.dtoolRelationsGrid.sortModel,
  dtoolRelationsGridFilterModel: state.appReducer.dtoolRelationsGrid.filterModel,
})

export default connect(mapStateToProps, {
  setDtoolRelationsGridVisibilityModel: appActions.setDtoolRelationsGridVisibilityModel,
  setDtoolRelationsGridSortModel: appActions.setDtoolRelationsGridSortModel,
  setDtoolRelationsGridFilterModel: appActions.setDtoolRelationsGridFilterModel,
  setActiveDtoolRelationId: appActions.setActiveDtoolRelationId,
})(DtoolRelationsTab)
